"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDirectiveMessage = exports.isPageMessage = exports.isPreserveExecutionOrderMessage = void 0;
const isPreserveExecutionOrderMessage = (msg) => !!msg.preserveExecutionOrder;
exports.isPreserveExecutionOrderMessage = isPreserveExecutionOrderMessage;
const isPageMessage = (msg) => !!msg.pageId;
exports.isPageMessage = isPageMessage;
const isDirectiveMessage = (msg) => !!msg.isDirective;
exports.isDirectiveMessage = isDirectiveMessage;
